'use strict';

var regexVer = /dp\/com\.dianping\.[\w\.]+\/([\d\.]+)/;

var getAppVersion = function (ua) {
  var version;
  var regexMAPI = /MApi/;
  var match  = ua.match(regexVer);
  if (match) {
    version = match[1];
  }else if (regexMAPI.test(ua)) {
    version = '7.0.0';
  }else{
    version = 'web';
  }
  return version;
};
var getOSName = function (ua) {
  var regexAndroid = /android/i;
  var regexIos = /ipad|iphone/i;
  if (regexAndroid.test(ua)) {
    return 'android';
  }else if (regexIos.test(ua)) {
    return 'ios';
  }
};

var getAdapterVersion = function (ua) {
  if (ua.match(regexVer)) {
    var reg = /adapter\/([\d\.]+)/;
    var match = ua.match(reg);
    if (match) {
      return match[1];
    }
  }
};

var getWebviewVersion = function(ua) {
  return getAdapterVersion(ua) || getAppVersion(ua);
};

var appVersion = getAppVersion(navigator.userAgent);
var osName = getOSName(navigator.userAgent);

module.exports = {
  appVersion: appVersion,
  getAppVersion: getAppVersion,
  osName: osName,
  getOSName: getOSName,
  getWebviewVersion: getWebviewVersion,
  actionMapping: function (method) {
    return function (opt) {
      this._send(method, opt);
    };
  }
};